<p libVisualGuideInitiator="pokazowy"></p>
<div data-vg="menu">
  <button (click)="step1 = !step1" mat-button>Pokaż krok 1</button>
  <button (click)="step2 = !step2" mat-button>Pokaż krok 2</button>
  <button (click)="step3$.next(!step3$.value)" mat-button>pokaż krok 3</button>
  <button (click)="step2 = !step2; step4 = !step4" mat-button>
    Pokaż krok 2 i 4
  </button>
  <button (click)="step3$.next(!step3$.value); step4 = !step4" mat-button>
    Pokaż krok 3 i 4
  </button>
</div>
<h1 data-vg="pokazowy_1">Start 1</h1>
<h1 data-vg="pokazowy_2">Start 2</h1>
<h1 data-vg="pokazowy_3">Start 3</h1>
@if (step1) {
  <div libVisualGuideInitiator="krok1">
    <h1 data-vg="pokazowy_1.1">Krok 1.1</h1>
    <h1 data-vg="pokazowy_1.2">Krok 1.2</h1>
    <h1 data-vg="pokazowy_1.3">Krok 1.3</h1>
  </div>
}
@if (step2) {
  <div libVisualGuideInitiator="krok2">
    <h1 data-vg="pokazowy_2.1">Krok 2.1</h1>
    <h1 data-vg="pokazowy_2.2">Krok 2.2</h1>
    <h1 data-vg="pokazowy_2.3">Krok 2.3</h1>
  </div>
}
@if (showStep3$ | async) {
  <div libVisualGuideInitiator="krok3">
    <h1 data-vg="pokazowy_3.1">Krok 3.1</h1>
    <h1 data-vg="pokazowy_3.2">Krok 3.2</h1>
    <h1 data-vg="pokazowy_3.3">Krok 3.3</h1>
  </div>
}
@if (step4) {
  <div libVisualGuideInitiator="krok4">
    <h1 data-vg="pokazowy_4.1">Krok 4.1</h1>
    <h1 data-vg="pokazowy_4.2">Krok 4.2</h1>
    <h1 data-vg="pokazowy_4.3">Krok 4.3</h1>
  </div>
}

<h1 data-vg="pokazowy_4">Start 4</h1>
<h1 data-vg="pokazowy_5">Start 5</h1>
<h1 data-vg="pokazowy_6">Start 6</h1>
